import { useState } from "react";

export type ErrorJson = {
  [key: string]: string;
};

export default function useErrors(): [
  ErrorJson,
  {
    removeError: (key: string) => void;
    setError: (key: string, message: string) => void;
    clearErrors: () => void;
  }
] {
  const [errors, setErrors] = useState<ErrorJson>({});

  const removeError = (key: string): void => {
    if (key in errors) {
      setErrors((prev) => {
        delete prev[key];
        return prev;
      });
    }
  };

  const setError = (key: string, message: string): void => {
    if (!(key in errors)) {
      setErrors((prev) => ({ ...prev, [key]: message }));
    }
  };

  const clearErrors = (): void => {
    setErrors({});
  };

  return [errors, { removeError, setError, clearErrors }];
}
